import React, { ReactNode } from 'react'
import { Media } from 'reactstrap'

interface ModalMediaContentProps {
    title: string
    icon: string | string[]
    children: ReactNode
    headingContent?: ReactNode
    headingClass?: string
    className?: string
}

/**
 * Wrapper that renders a reactstrap Media layout with a Font Awesome icon,
 * a heading block, and arbitrary children.
 */
const ModalMediaContent = ({
    children,
    icon,
    title,
    headingClass = '',
    headingContent,
}: ModalMediaContentProps) => {
    return (
        <Media className="mt-3">
            <span className="fa-stack ml-n1">
                <i className={`fas ${icon} text-primary`} />
            </span>
            <Media body>
                <Media heading tag="div" className={`mb-2 mt-2 ${headingClass}`}>
                    <h5 className="fs-0 font-weight-bold">{title}</h5>
                    {headingContent}
                </Media>
                {children}
            </Media>
        </Media>
    )
}

export default ModalMediaContent
